<template>
  <div class="dovemed-container mt-0">
    <div class="dovemed-wrapper text-center signup-page">
      <div v-if="formResponses.role === 'advocate'" class="signup-container mt-5" v-bind:style="{ 'max-width': '587px' }">
        <h2 class="hyper-link mb-3 font-weight-bold welcome-message">
          <div>Welcome to</div>
          <div>{{ currentCircle.condition_type }}{{ !currentCircle.condition_type.toLowerCase().includes("circle") ? " Circle" : "" }}</div>
        </h2>
        <p class="get-started">Fill in the Advocate details</p>
        <div class="row m-0 profile-form">
          <div class="profile-form__card">
            <div class="user-wrapper">
              <div class="user-avatar">
                <img src="../../../assets/icons/bullHorn.svg" alt="" />
              </div>
              <div class="registering-message">You are registering as an {{ $route.query.role | humanize }}</div>
            </div>
            <div class="change" @click="$router.go(-1)" :style="{ color: getPrimaryColor() }">Change</div>
          </div>
          <div class="col-md-12 col-sm-12 formWrapper">
            <div class="d-flex input-container">
              <div class="row mt-4">
                <div class="col-md-6 col-sm-12 mb-2 text-left type-input mobile-margin">
                  <label for="displayName" class="mb-1 input-label">
                    First Name
                    <span class="required">*</span>
                  </label>
                  <a-input :size="'large'" placeholder="Provide first name" class="formInput" v-model.lazy="$v.formResponses.displayName.$model" />
                  <div class="error-container" v-if="$v.formResponses.displayName.$error">
                    <div class="error-item" v-if="!$v.formResponses.displayName.required">First name is required</div>
                    <div class="error-item" v-if="!$v.formResponses.displayName.minLength">Minimum length is 1</div>
                    <div class="error-item" v-if="!$v.formResponses.displayName.maxLength">Maxium length is 20</div>
                    <div class="error-item" v-if="!$v.formResponses.displayName.isAplhaNum && $v.formResponses.displayName.required">Please enter a valid First name</div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 mb-2 text-left type-input">
                  <label for="displayName" class="mb-1 input-label">
                    Last Name
                    <span class="required">*</span>
                  </label>
                  <a-input :size="'large'" class="formInput" placeholder="Provide last name" v-model.lazy="$v.formResponses.last_name.$model" />
                  <div class="error-container" v-if="$v.formResponses.last_name.$error">
                    <div class="error-item" v-if="!$v.formResponses.last_name.required">Last name is required</div>
                    <div class="error-item" v-if="!$v.formResponses.last_name.minLength">Minimum length is 1</div>
                    <div class="error-item" v-if="!$v.formResponses.last_name.maxLength">Maxium length is 20</div>
                    <div class="error-item" v-if="!$v.formResponses.last_name.isAplhaNum && $v.formResponses.last_name.required">Please enter a valid last name</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="d-flex input-container">
              <div class="row mt-4">
                <div class="col-md-6 col-sm-12 mb-2 text-left type-input mobile-margin">
                  <label for="organization" class="mb-1 input-label"> Organization You Support </label>
                  <a-input :size="'large'" class="formInput" :disabled="myself" placeholder="Provide organization name" v-model.lazy="$v.formResponses.organization.$model" />
                  <div class="error-container" v-if="!myself && $v.formResponses.organization.$error">
                    <div class="error-item" v-if="!$v.formResponses.organization.required">Organization is required</div>
                    <div class="error-item" v-if="!$v.formResponses.organization.maxLength">Maxium length is 25</div>
                  </div>
                </div>
                <div class="col-md-6 col-sm-12 mb-2 text-left type-input">
                  <label for="designation" class="mb-1 input-label"> Designation </label>
                  <a-input :size="'large'" class="formInput" :disabled="myself" placeholder="Provide designation" v-model.lazy="$v.formResponses.designation.$model" />
                  <div class="error-container" v-if="!myself && $v.formResponses.designation.$error">
                    <div class="error-item" v-if="!$v.formResponses.designation.required">Designation is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="myself mt-4">
              <input type="checkbox" class="check-box" :checked="myself" @change="toggleMyself" />
              <span>I Represent Myself</span>
            </div>
            <div class="row mt-4">
              <div class="col-md-6 col-sm-12 mb-2 text-left type-input mobile-margin">
                <label for="city" class="mb-1 input-label"> City <span class="required">*</span> </label>
                <div class="search-input br0 position-relative">
                  <!-- <font-awesome-icon
                    size="1x"
                    :icon="['fal', 'search']"
                    class="position-absolute search-icon"
                  /> -->
                  <a-select
                    show-search
                    :size="'large'"
                    class="w-100"
                    placeholder="Search City"
                    style="width: 120px"
                    :default-active-first-option="false"
                    :show-arrow="false"
                    :filter-option="false"
                    :defaultValue="formResponses.city && formResponses.state ? formResponses.city + ' , ' + formResponses.state : undefined"
                    @search="val => getLocations(val)"
                    @select="val => selectLocation(val)"
                  >
                    <a-select-option v-if="loadingLocation" :key="0" :disabled="true">
                      <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                    </a-select-option>
                    <template v-else>
                      <a-select-option v-for="c in locationsList" :key="JSON.stringify(c)">{{ c.name }}, {{ c.state }} </a-select-option>
                    </template>
                  </a-select>
                </div>
                <div :style="{ color: '#94A3B8', 'font-weight': '400', 'font-size': '12px' }">MyCircles is currently only available in the USA</div>
                <div class="error-container" v-if="$v.formResponses.city.$error">
                  <div class="error-item" v-if="!$v.formResponses.city.required">City is required</div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 mb-2 text-left type-input mobile-margin">
                <label for="zipcode" class="mb-1 input-label"> Zipcode </label>
                <br />
                <a-select
                  class="w-100"
                  :min="0"
                  :size="'large'"
                  placeholder="Zipcode"
                  v-model="$v.formResponses.zip_code.$model"
                  :defaultValue="formResponses.zipcode"
                  :disabled="formResponses.city ? false : true"
                >
                  <a-select-option v-if="loadingZipCodes" :key="0" :disabled="true">
                    <span> <a-spin size="small" class="mr-2" /> Loading... </span>
                  </a-select-option>
                  <template v-else>
                    <a-select-option v-for="zipcode in zipCodeArray" :key="zipcode"> {{ zipcode }} </a-select-option>
                  </template>
                </a-select>
                <div class="error-container" v-if="$v.formResponses.zip_code.$error">
                  <div class="error-item" v-if="!$v.formResponses.zip_code.required">Zipcode is required</div>
                </div>
              </div>
            </div>
            <div class="row mt-3 mobile-zero-margin"></div>
            <div class="row mt-3 mobile-zero-margin">
              <div class="col-md-6 col-sm-12 text-left mb-2 type-input mobile-margin">
                <label for="birthday" class="mb-1 input-label"> My Birthday <span class="required">*</span> </label>
                <!-- <a-month-picker
                  class="d-inline-block pr-0 w-100"
                  :size="'large'"
                  placeholder="Provide month and year"
                  :disabledDate="disabledDate"
                  @change="handleBirthDateChange"
                  :defaultPickerValue="maxBirthdayDate"
                  v-model="formResponses.birthDate"
                >
                  <template v-if="formResponses.birthDate" #suffixIcon>
                    <font-awesome-icon
                      :icon="['far', 'times']"
                      class="gray400 cp show-in-mobile"
                      @click="
                        () => {
                          formResponses.birthDate = null
                        }
                      "
                    />
                  </template>
                </a-month-picker> -->
                <DatePicker
                  v-model="formResponses.birthDate"
                  :disabled-date="disabledDate"
                  placeholder="Provide month and year"
                  type="month"
                  class="w-100 new-datepicker"
                  :append-to-body="false"
                  :clearable="false"
                  :default-value="maxBirthdayDate"
                />
                <!-- :defaultValue="formResponses.birthDate" -->
                <div class="error-container" v-if="$v.formResponses.birthDate.$error">
                  <div class="error-item" v-if="!$v.formResponses.birthDate.required">DOB is required</div>
                </div>
              </div>
              <div class="col-md-6 col-sm-12 text-left mb-2 type-input">
                <label for="gender" class="mb-1 input-label"> Gender </label>
                <div class>
                  <a-select :size="'large'" class="w-100" placeholder="Select gender" :defaultValue="formResponses.gender" style="width: 120px" v-model="$v.formResponses.gender.$model">
                    <a-select-option value="male">Male</a-select-option>
                    <a-select-option value="female">Female</a-select-option>
                    <a-select-option value="other">Other</a-select-option>
                  </a-select>
                  <div class="error-container" v-if="$v.formResponses.gender.$error">
                    <div class="error-item" v-if="!$v.formResponses.gender.required">Gender is required</div>
                  </div>
                </div>
              </div>
            </div>
            <div class="button-container">
              <div class="terms-conditions">
                <input type="checkbox" class="check-box" :checked="termsCondition" @change="toggleTermsConditions" />
                <span>I Agree to<span class="tandc" @click="handleTermsAndCondtions()">Terms and Conditions</span> of DoveMed</span>
              </div>
              <div class="buttons-group text-right d-flex" :style="{ gap: '10px' }">
                <button class="dovemed-button primary-border hyper-link back-btn" @click="redirectBack()" :style="{ background: '#E2E8F0', color: '#47556E', 'border-radius': '6px' }">Back</button>
                <a-button
                  :loading="loading"
                  :disabled="!termsCondition || !formResponses.city || !formResponses.birthDate || !formResponses.displayName || !formResponses.last_name"
                  type="submit"
                  class="dovemed-button font-white primary-button next-btn"
                  :style="{
                    background: getPrimaryColor(),
                    opacity: termsCondition && formResponses.city && formResponses.birthDate && formResponses.displayName && formResponses.last_name ? '1' : '0.3',
                    'border-radius': '8px',
                  }"
                  @click.prevent="handleSubmit"
                >
                  Next
                </a-button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <h1 v-else>
        <h3 class="redirect-header">We dont support Healthcare Professional Registration.</h3>
        <p class="redirect-description">To register as a healtcare professional</p>
        <a class="redirect-link-wrapper" target="_blank" href="https://dovemed.com"> <div class="redirect-link" v-bind:style="{ background: getPrimaryColor() }">Click here</div> </a>
      </h1>
    </div>
    <EmailVerifyModal ref="emailVerifyModal" />
  </div>
</template>

<script>
import { required, minLength, email, requiredIf, maxLength } from "vuelidate/lib/validators"
import { mapGetters } from "vuex"
import Repository from "../../../repositories/Repository"
import EmailVerifyModal from "../../Modals/EmailVerification"
import DatePicker from "vue2-datepicker"
import axios from "axios"

export default {
  name: "WelcomeAdvocate",
  computed: { ...mapGetters({ currentCircle: "Circle/currentCircle" }) },
  components: { EmailVerifyModal, DatePicker },
  data() {
    return {
      loadingLocation: false,
      loadingZipCodes: false,
      maxBirthdayDate: "",
      month: ["Jan", "Feb", "Mar", "April", "May", "June", "July", "Aug", "Sep", "Oct", "Nov", "Dec"],
      authenticated: false,
      uiState: "submit_not_clicked",
      loading: false,
      empty: true,
      errors: false,
      country: [],
      state: [],
      dataOfmonth: null,
      locationsList: [],
      zipCodeArray: [],
      formResponses: {
        displayName: null,
        displayNameResponse: null,
        last_name: null,
        password: undefined,
        email: undefined,
        birthDate: null,
        organization: null,
        designation: null,
        gender: null,
        role: null,
        address_line1: null,
        address_line2: null,
        city: null,
        state: "USA",
        country: null,
        zip_code: null,
      },
      myself: false,
      termsCondition: false,
    }
  },
  validations: {
    formResponses: {
      displayName: {
        required,
        minLength: minLength(1),
        maxLength: maxLength(20),

        isAplhaNum() {
          const regex = /[a-zA-Z]/
          const doesItHaveLetter = regex.test(this.formResponses.displayName)
          return doesItHaveLetter ? true : false
        },
      },
      last_name: {
        minLength: minLength(1),
        maxLength: maxLength(20),
        required,
        isAplhaNum() {
          const regex = /[a-zA-Z]/
          const doesItHaveLetter = regex.test(this.formResponses.last_name)
          return doesItHaveLetter ? true : false
        },
      },
      password: {
        required: requiredIf(function() {
          return !this.authUser
        }),
      },
      email: {
        // required,
        // email
      },
      organization: {
        maxLength: maxLength(25),
      },
      designation: {},
      role: {
        required,
      },
      birthDate: {
        required,
      },
      gender: {
        // required
      },
      city: {
        required,
      },
      state: {
        // required
      },
      country: {
        // required
      },
      zip_code: {
        // required
      },
    },
  },

  created() {
    this.formResponses.role = this.$route.query.role
    this.fillDataIfAuthorized()
    this.getLocations("")
    this.maxBirthdayDate = this.moment().subtract(18, "years")
  },

  mounted() {
    window.scrollTo(0, 0)
  },

  methods: {
    disabledDate(current) {
      return (
        current &&
        current >
          this.moment()
            .endOf("day")
            .subtract(18, "years")
      )
    },

    async getLocations(city) {
      try {
        this.loadingLocation = true
        const coreLocationResponse = await axios.get(`${process.env.SSO_BASE_URL}/api/v2/dovescore/city/?name=${city}`)
        this.locationsList = coreLocationResponse.data.results || []
        this.loadingLocation = false
      } catch (e) {
        this.loadingLocation = false
        this.$notification.error({ message: "Try Again", description: "Error while fetching location" })
      }
    },

    async selectLocation(val) {
      const value = JSON.parse(val)
      this.formResponses.city = value.name
      this.formResponses.state = value.state
      this.formResponses.zip_code = null
      try {
        this.loadingZipCodes = true
        const zipCodeRes = await axios.get(`${process.env.SSO_BASE_URL}/api/v2/dovescore/zipcode/?page_size=50&city=${value.name}`)
        this.zipCodeArray = zipCodeRes.data.results.map(data => data.zipCode) || []
        this.loadingZipCodes = false
      } catch (e) {
        this.loadingZipCodes = false
        this.$notification.error({ message: "Try Again", description: "Error while fetching zip codes" })
      }
    },

    fillDataIfAuthorized() {
      if (this.authUser) {
        this.authenticated = true
        const user = this.authUser.user

        this.formResponses.email = user.email
        this.formResponses.birthDate = user.dob ? new Date(user.dob) : null
        // this.formResponses.birthDate = user.dob ? this.moment(user.dob).format("YYYY-MM-DD") : null
        this.formResponses.gender = user.gender
        if (user.location && user.location.length) {
          this.formResponses.city = user.location[0].city || undefined
          this.formResponses.state = user.location[0].state || undefined
          // this.formResponses.country = user.location[0].country
          this.formResponses.zip_code = user.location[0].zip_code || undefined
        }
      } else {
        this.formResponses.email = undefined
        this.formResponses.password = undefined
      }
      console.log("fillDataIfAuthorized() -> formResponses:", this.formResponses)
    },
    redirectBack() {
      this.$router.go(-1)
    },
    handleTags(value) {
      this.formResponses.additionalConditions = value
      this.$v.formResponses.additionalConditions.$touch()
    },
    handleDiagnosisDateChange(date, dateString) {
      this.formResponses.diagnosisDate = dateString
      this.$v.formResponses.diagnosisDate.$touch()
    },
    handleBirthDateChange(date, dateString) {
      this.formResponses.birthDate = dateString + "-01"
      this.$v.formResponses.birthDate.$touch()
    },
    handleSubmit() {
      this.empty = !this.$v.formResponses.$anyDirty
      this.errors = this.$v.formResponses.$anyError

      this.uiState = "submit_clicked"
      if (this.$v.formResponses.$anyError === false && this.empty === false && this.formResponses.displayName != null && this.formResponses.last_name != null && this.formResponses.city != null) {
        const currentCircle = JSON.parse(localStorage.getItem("currentCircle"))

        const payload = {
          email: this.formResponses.email,
          password: this.formResponses.password,
          first_name: this.formResponses.displayName.trim(),
          middle_name: "",
          last_name: this.formResponses.last_name.trim(),
          display_name: this.formResponses.displayName.trim() + " " + this.formResponses.last_name.trim(),
          role: this.formResponses.role,
          gender: this.formResponses.gender,
          dob: this.moment(this.formResponses.birthDate).format("YYYY-MM-DD"),
          advocate: {
            designation: this.formResponses.designation,
            represent_organization: this.formResponses.organization,
          },
          user_circle: {
            circle: currentCircle.id,
          },
          location: {
            address_line1: this.formResponses.address_line1,
            address_line2: this.formResponses.address_line2,
            city: this.formResponses.city,
            state: this.formResponses.state,
            country: this.formResponses.country,
            zip_code: this.formResponses.zip_code,
          },
          send_updates: this.$route.query.send_updates === "true" ? true : false,
        }

        this.loading = true
        this.$store
          .dispatch("Signup/createUser", { payload })
          .then(data => {
            this.uiState = "form_submitted"
            // this.$router.push({ name: 'Home' })
            const user = JSON.parse(localStorage.getItem("user"))
            Repository.defaults.headers.common["Authorization"] = `Bearer ${user.user.token}`
            this.loading = false

            this.$router.push({
              path: `/${this.currentCircle.condition_type}/home/activity`,
            })
          })
          .catch(error => {
            this.loading = false
            this.$notification.error({
              message: "Error",
              description: error,
            })
          })
      } else {
        this.loading = false
        this.uiState = "validation_failed"

        this.$v.$touch()
      }
    },
    toggleMyself(e) {
      this.myself = e.target.checked
    },
    toggleTermsConditions(e) {
      this.termsCondition = e.target.checked
    },
    handleTermsAndCondtions() {
      window.open(`${process.env.SSO_BASE_URL}/help-center/faq/mycircles-terms-of-use`)
    },
  },

  filters: {
    humanize: function(value, capitalize = false) {
      if (!value) return ""
      return capitalize
        ? value
            .toLowerCase()
            .split("_")
            .map(e => e.toUpperCase())
            .join(" ")
        : value
            .toLowerCase()
            .split("_")
            .map(e => e.charAt(0).toUpperCase() + e.substring(1))
            .join(" ")
    },
  },
}
</script>

<style lang="scss" scoped>
@media screen and (max-width: 427px) {
  .signup-container {
    width: 100% !important;
    margin-top: 1rem !important;
    padding: 0px !important;
  }
  .input-container {
    flex-direction: column;
    gap: 24px !important;
  }

  .formInput {
    width: 385px !important;
  }
  .button-container {
    margin-top: 48px !important;
    gap: 48px !important;
    flex-direction: column;
  }
  .next-btn {
    padding: 12px 24px !important;
    width: 195.5px !important;
  }

  .back-btn {
    padding: 12px 24px !important;
    width: 195.5px !important;
  }

  .mobile-margin {
    margin-bottom: 24px !important;
  }
  .mobile-zero-margin {
    margin-top: 0px !important;
  }
}

@media screen and (max-width: 376px) {
  .formInput {
    width: 320px !important;
  }
  .signup-container {
    padding: 0px !important;
  }
}

.signup-container {
  padding: 24px;
}
.input-container {
  gap: 24px;
}
.formWrapper {
  padding: 0;
}
.next-btn {
  padding: 12px 24px;
  width: 79px;
  height: 48px;
}
.formInput {
  padding: 16px;
  height: 56px;
  width: 257.5px;
  border: 1px solid #cbd5e1;
  border-radius: 8px;
}
.profile-form {
  &__card {
    padding: 16px;
    margin: 24px 0;
    width: 100%;
    background: #f8fafd;
    box-shadow: 0px 2px 8px rgba(60, 60, 60, 0.1);
    border-radius: 4px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .user-wrapper {
      display: flex;
      align-items: center;
    }
    .registering-message {
      color: #647490;
      font-size: 16px;
      font-weight: 400;
      margin: 0 16px;
      text-align: left;
    }
    .user-avatar {
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background: #f1f5f9;
      display: flex;
      justify-content: center;
      align-items: center;
      img {
        width: 15px;
        height: 15px;
      }
    }
    .change {
      // color: #2A71D4;
      font-size: 14px;
      font-weight: 700;
      cursor: pointer;
    }
  }
}

.input-label {
  color: #647490;
  font-weight: 700;
}
.back-btn {
  padding: 12px 24px;
  width: 79px;
  height: 48px;
  border: none !important;
}
.welcome-message {
  font-size: 36px;
  font-weight: 700;
  margin-top: 0 !important;
}
.get-started {
  color: #647490;
  font-size: 16px;
  font-weight: 400;
}

.desc-card {
  padding: 24px 30px;
  border-radius: 2px;
  background-color: #f3f7fd;
  text-align: left;
  h3 {
    color: #333333;
    font-family: Lato;
    font-size: 21px;
    font-weight: bold;
    padding-bottom: 16px;
    line-height: 1;
    margin: 0;
  }
  p {
    color: #333333;
    font-family: Lato;
    font-size: 16px;
    margin: 0;
  }
}
.myself {
  text-align: left;
  display: flex;

  span {
    font-family: "Lato";
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #0f1734;
    margin-left: 8px;
  }
}
.required {
  color: tomato !important;
}
.redirect-header {
  color: #333;
  font-size: 16px;
}
.redirect-description {
  font-size: 14px;
  color: #444;
}
.redirect-link {
  font-size: 13px;
  padding: 8px 15px;
  border-radius: 20px;
  width: 150px;
  text-transform: uppercase;
  margin: 0 auto;
  color: #fff;
  font-family: Lato;
  font-weight: bold;
  transition: 0.2s all ease-in;
  &:hover {
    transform: scale(0.98);
  }
}
.redirect-link-wrapper {
  text-decoration: none !important;
  &:hover {
    text-decoration: none !important;
  }
}
.date-pick {
  transform: scaleY(1.078);
  margin-top: 2px;
}

.terms-conditions {
  display: flex;
  justify-content: flex-start;
  align-items: center;

  span {
    padding-left: 5px;
    font-weight: 400;
    font-size: 14px;
    line-height: 21px;
    color: #0f1734;

    @media screen and (max-width: 900px) {
      padding: 1px;
    }
  }
}

// .terms-conditions {
//   margin-top: 27px;
// }
.terms-conditions span {
  padding-left: 5px;
}
.terms-conditions a {
  color: #2a71d4 !important;
}
.terms-conditions input {
  cursor: pointer;
}
.tandc {
  text-decoration: none;
  cursor: pointer;
  color: #2a71d4 !important;
}

.button-container {
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
  margin-top: 45.5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Signup/UserProfile/WelcomeAdvocate.vue